export default __webpack_public_path__ + "static/media/food2.eddafc87.jpg";